import {
    SET_FILTER,
    SET_CURRENT_STYLE
} from './Types';

export const setFilter = (uid, filters) => ({
    type: SET_FILTER,
    uid,
    filters
});

export const setCurrentStyle = (uid, styleIdx) => ({
    type: SET_CURRENT_STYLE,
    uid,
    styleIdx
});

// Turns filter into simplified for url parse eg. categories_aggregate=Company,Corporate Body&tenure_aggregate=Freehold - should do selects as index
// TODO - best to attach functionality to ibject directly somehow
export function SimplifyFilters (fields, filters) {
    return filters
        .map(filter => {
            const field = fields[filter.field];
            switch (field.type) {
                case 'area':
                    if ((!filter.properties.value0 && !filter.properties.value1) || !filter.properties.unit) { return null; }
                    return `${filter.field}=${filter.properties.value0 || ''},${filter.properties.value1 || ''},${filter.properties.unit}`;
                case 'select':
                    if (!filter.properties.value) { return null; }
                    return `${filter.field}=${filter.properties.value}`;
                case 'multiselect':
                    if (!filter.properties.values || filter.properties.values.length === 0) { return null; }
                    return filter.properties.values.map(v => `${filter.field}[]=${v}`).join('&');
                    // return `${filter.field}=${filter.properties.values.join(',')}`;
                case 'integer':
                    if (!filter.properties.value0 && !filter.properties.value1) { return null; }
                    return `${filter.field}=${filter.properties.value0 || ''},${filter.properties.value1 || ''}`;
                case 'date':
                    if (!filter.properties.value0 && !filter.properties.value1) { return null; }
                    return `${filter.field}=${filter.properties.value0 || ''},${filter.properties.value1 || ''}`;
                case 'string':
                    if (!filter.properties.value) { return null; }
                    return `${filter.field}=${filter.properties.value}`;
                case 'multistring':
                    if (!filter.properties.values || filter.properties.values.length === 0) { return null; }
                    return filter.properties.values.map(v => `${filter.field}[]=${v}`).join('&');
                default:
                    return null;
            }
        })
        .filter(f => f !== null)
        .join('&');
}